import type { CFilesToDownloadTranslations } from "./pl";

/**
 * CFilesToDownload - deutsche Übersetzungen (Dateien zum Herunterladen).
 */
export const de: CFilesToDownloadTranslations = {
  emptyData: "Keine Daten zum Anzeigen.",
  emptyList: "Keine Dateien in diesem Bereich.",
  categoryLabel: "Kategorie",
  allCategories: "Alle Kategorien",
  back: "<- Zurück",
  download: "Datei herunterladen",
  requiresLogin: "Nur für angemeldete Benutzer",
  requiresAdmin: "Nur für Administratoren",
  fileFallbackExt: "DATEI",
  units: {
    kb: "KB",
    mb: "MB",
  },
};
